/* import __COLOCATED_TEMPLATE__ from './welcome-header.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./welcome-header.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());